import { Col, Form, Row, Tab, Table, Tabs } from 'react-bootstrap'
import Navbar from '../../../components/navbar/navbar'
import { Container, Footer, Union } from './styles'
import {
  PlusCircle,
  Search,
  TrashFill,
  WrenchAdjustableCircleFill,
} from 'react-bootstrap-icons'
import { IconButton } from '../../../components/IconButton'
import { useEffect, useState } from 'react'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'
import WmsProductService from '../../../services/database/WmsProductService'
import { CustomButton } from '../../../components/CustomButton'
import { ModalAddToList } from './ModalAddToList'
import WmsEstEnderecoService from '../../../services/database/WmsEstEnderecoService'
import { toast } from 'react-toastify'
import { validateValue } from '../../../utils/validateValue'

export function AjustarEstoqueEndereco() {
  const [data, setData] = useState({
    sku: '',
    descricao: '',
  })

  const [productsToAdjust, setProductsToAdjust] = useState([])

  const [selectedSkus, setSelectedSkus] = useState([])

  const [selectedProduct, setSelectedProduct] = useState({})

  const [isModalAddToListOpen, setIsModalAddToListOpen] = useState(false)

  const [isAdjustProductLoading, setIsAdjustProductLoading] = useState(false)

  async function handleSearchProduct() {
    try {
      const product = await WmsProductService.getAdjustmentBySku(data.sku)

      setData(product)
      setSelectedProduct({})
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar o produto!')
    }
  }

  async function handleAdjust() {
    try {
      setIsAdjustProductLoading(true)

      await WmsEstEnderecoService.insertUpdate(productsToAdjust)

      setData({
        sku: '',
        descricao: '',
      })

      setProductsToAdjust([])

      localStorage.removeItem('productsToAdjust')

      toast.success('Estoque dos produtos ajustados com sucesso!')
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível ajustar o estoque dos produtos!',
      )
    } finally {
      setIsAdjustProductLoading(false)
    }
  }

  function handleRemoveSelecteds() {
    for (const selectedSku of selectedSkus) {
      setSelectedSkus((prevState) =>
        prevState.filter((sku) => sku !== selectedSku),
      )

      setProductsToAdjust((prevState) =>
        prevState.filter((product) => product.sku !== selectedSku),
      )
    }
  }

  function addProductToAdjust(product) {
    localStorage.setItem(
      'productsToAdjust',
      JSON.stringify([...productsToAdjust, product]),
    )
    setProductsToAdjust((prevState) => [...prevState, product])

    setSelectedProduct({})

    setData({
      sku: '',
      descricao: '',
    })
  }

  function handleChange(e) {
    const { name, value } = e.target

    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  function getProductsToAdjust() {
    const data = localStorage.getItem('productsToAdjust')

    if (data) {
      setProductsToAdjust(JSON.parse(data))
    }
  }

  useEffect(() => {
    getProductsToAdjust()
  }, [])

  return (
    <>
      <Navbar />

      <Container className="mt-page">
        <h1>Ajustar Estoque por Endereço</h1>

        <Tabs
          defaultActiveKey="transferencias"
          className="mb-3"
          fill
        >
          <Tab
            eventKey="transferencias"
            title="Seleções para Transferências"
            style={{
              height: '100%',
            }}
          >
            <p>Produto a ser transferido</p>

            <Row>
              <Col>
                <Form.Label>SKU</Form.Label>

                <Union>
                  <Form.Control
                    name="sku"
                    value={data.sku}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleSearchProduct()
                      }
                    }}
                  />

                  <IconButton
                    onClick={handleSearchProduct}
                    isDisabled={!data.sku.trim()}
                  >
                    <Search />
                  </IconButton>
                </Union>
              </Col>

              <Col>
                <Form.Label>Descrição</Form.Label>
                <Form.Control
                  name="descricao"
                  value={data.descricao}
                  onChange={handleChange}
                  disabled
                />
              </Col>
            </Row>

            {data?.codendereco ? (
              <Table
                striped
                bordered
              >
                <thead>
                  <tr>
                    <th>Selec.</th>
                    <th>Cód. End.</th>
                    <th>Tipo End.</th>
                    <th>Depósito</th>
                    <th>Rua</th>
                    <th>Prédio</th>
                    <th>Niv.</th>
                    <th>Apto</th>
                    <th>Qt Disp.</th>
                    <th>Qt Pend. Entrada</th>
                    <th>Qt Pend. Saída</th>
                    <th>Qt Bloq.</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>
                      <Form.Check
                        checked={
                          data.codendereco === selectedProduct.codendereco
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedProduct(data)
                          } else {
                            setSelectedProduct({})
                          }
                        }}
                        disabled={!data.codendereco}
                      />
                    </td>

                    <td>{String(data.codendereco)}</td>
                    <td>
                      {data.tipoender === 'AP'
                        ? 'Picking'
                        : data.tipoender === 'AE'
                          ? 'Aéreo'
                          : 'N/I'}
                    </td>
                    <td>{data.deposito}</td>
                    <td>{data.rua}</td>
                    <td>{data.predio}</td>
                    <td>{validateValue(data.nivel)}</td>
                    <td>{data.apto}</td>
                    <td>{validateValue(data.qt)}</td>
                    <td>{validateValue(data.qtpendentrada)}</td>
                    <td>{validateValue(data.qtpendsaida)}</td>
                    <td>{validateValue(data.qtbloqueada)}</td>
                  </tr>
                </tbody>
              </Table>
            ) : (
              <p className="mt-4">Produto não endereçado!</p>
            )}

            <Footer>
              {/* <CustomButton
                title="Novo endereco"
                onClick={() => setIsModalAddToListOpen(true)}
                isDisabled={data?.codendereco || !data.descricao}
              >
                <PlusCircle />
              </CustomButton> */}

              <CustomButton
                title="Adic. à lista"
                onClick={() => setIsModalAddToListOpen(true)}
                isDisabled={!selectedProduct.codendereco}
              >
                <PlusCircle />
              </CustomButton>
            </Footer>
          </Tab>

          <Tab
            eventKey="ajustes"
            title="Lista de Ajustes"
          >
            {productsToAdjust.length > 0 ? (
              <Table responsive>
                <thead>
                  <tr>
                    <th></th>
                    <th>SKU</th>
                    <th>Descrição</th>
                    <th>Cód. Ende.</th>
                    <th>Rua</th>
                    <th>Prédio</th>
                    <th>Nível</th>
                    <th>Apto</th>
                    <th>Qt. Atual</th>
                    <th>Tipo Ajus.</th>
                    <th>Qt. Ajus.</th>
                    <th>Ajus. Est. Ger.</th>
                    <th>Motivo</th>
                    <th>Obs.</th>
                  </tr>
                </thead>
                <tbody>
                  {productsToAdjust.map((product) => (
                    <tr>
                      <td>
                        <Form.Check
                          checked={selectedSkus.includes(product.sku)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedSkus((prevState) => [
                                ...prevState,
                                product.sku,
                              ])
                            } else {
                              setSelectedSkus((prevState) =>
                                prevState.filter((sku) => sku !== product.sku),
                              )
                            }
                          }}
                        />
                      </td>

                      <td
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {product.sku}
                      </td>
                      <td
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {product.descricao}
                      </td>
                      <td
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {product.codendereco}
                      </td>
                      <td
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {product.rua}
                      </td>
                      <td
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {product.predio}
                      </td>
                      <td
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {product.nivel}
                      </td>
                      <td
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {product.apto}
                      </td>
                      <td
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {product.qt || '0'}
                      </td>
                      <td
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {product.tipo_ajuste}
                      </td>
                      <td
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {product.quantidade}
                      </td>
                      <td
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {product.ajustar_estoque_gerencial}
                      </td>
                      <td
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {product.desc_motivo}
                      </td>
                      <td
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {product.obs}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p>Sem produtos na lista!</p>
            )}

            <Footer>
              <CustomButton
                title="Ajustar"
                onClick={handleAdjust}
                isDisabled={productsToAdjust.length === 0}
                isLoading={isAdjustProductLoading}
              >
                <WrenchAdjustableCircleFill />
              </CustomButton>

              <CustomButton
                color="#e74c3c"
                title="Deletar Selecionados"
                isDisabled={selectedSkus.length === 0}
                onClick={handleRemoveSelecteds}
              >
                <TrashFill />
              </CustomButton>
            </Footer>
          </Tab>
        </Tabs>
      </Container>

      {isModalAddToListOpen && (
        <ModalAddToList
          isOpen={isModalAddToListOpen}
          onClose={() => setIsModalAddToListOpen(false)}
          product={selectedProduct}
          onAddProduct={addProductToAdjust}
        />
      )}
    </>
  )
}
